import formatIntegerBySpace from '../../../../helpers/formatters/format-integer-by-space'
import { getShipmentDisplayCopiesSum } from '../../../../helpers/entities/shipment/get-shipment-display-copies'
import { renderShipment } from '../../helpers/helpers'
import type { ShipmentColumn } from '../../types/column-types'

export const copiesColumn: ShipmentColumn = {
    key: 'copies',
    dataIndex: 'copies',
    title: 'Тираж',
    width: 70,
    render: renderShipment(r =>
        formatIntegerBySpace(getShipmentDisplayCopiesSum(r.shipment_positions))
    ),
}
